import { render, staticRenderFns } from "./CustomerStats.vue?vue&type=template&id=5aaf8a7c&"
import script from "./CustomerStats.vue?vue&type=script&lang=js&"
export * from "./CustomerStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports